import { SCREEN_BREAKPOINT } from '@components/Grid/Grid.style';
import { StyledLabel, StyledParagraph } from '@components/Text';
import styled from '@emotion/styled';

export const StyledProductBtnOptions = styled.div<{ height?: number; fixed?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  padding: 0px;
  gap: 8px;

  width: 100%;
  height: ${({ height }) => (height ? `${height}px` : '44px')};

  ${({ fixed }) =>
    fixed == true
      ? `
  position: sticky;
  top: 0px;
  z-index: 99;
  background-color: white;

  border-bottom: 1px solid rgba(0, 0, 0, 0.08);`
      : ``};

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    padding: 0 24px;
    justify-content: flex-start;
    overflow-x: auto;
    white-space: nowrap;

    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;

export const StyledProductBtn = styled.div<{ index: number; selectedIndex: number }>`
  padding: 16px;
  gap: 10px;

  height: 100%;
  display: flex;
  align-items: center;

  flex: none;
  order: 0;
  flex-grow: 0;

  ${({ index, selectedIndex }) => (index === selectedIndex ? `border-bottom : 1px solid #2A70F0;` : '')}

  cursor : pointer;
`;

export const StyledProductBtnA = styled.a<{ index: number; selectedIndex: number }>`
  padding: 16px;
  height: 100%;
  display: flex;
  align-items: center;

  flex: none;
  order: 0;
  flex-grow: 0;

  ${({ index, selectedIndex }) => (index === selectedIndex ? `border-bottom : 1px solid #2A70F0;` : '')}

  cursor : pointer;
`;

export const BtnLabel = styled(StyledLabel)<{ index: number; selectedIndex: number }>`
  ${({ index, selectedIndex }) => (index === selectedIndex ? `color : #000;` : 'color : #818181;')}
`;

export const StyledProductImgBig = styled.img<{ marginTop?: string }>`
  width: 100%;
  max-height: 520px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 16px;
  background: #f8f8f8;

  padding: auto;
  margin-top: ${({ marginTop }) => (marginTop ? `${marginTop}px;` : '32px;')};

  object-fit: contain;

  aspect-ratio: auto 1232 / 520;

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
    width: 100%;
    max-height: 440px;
    aspect-ratio: auto 1287 / 912;
  }

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    display: block;
    margin-top: 16px;
    margin-bottom: 0px;
    aspect-ratio: 360 / 360;
  }
`;

export const StyledProductImgBig2 = styled.img`
  max-width: 100%;
  max-height: auto;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 16px;
  background: #f8f8f8;

  padding: auto;
  margin-top: 32px;

  object-fit: fit;

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
    width: 100%;
    max-height: 440px;
  }

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    height: 380px;
    object-fit: cover;
  }
`;

export const StyledProductImgBox = styled.div`
  margin-top: 32px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 32px;

  object-fit: contain;

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    flex-direction: column;
    width: 100%;
    margin-top: 16px;
    gap: 16px;
  }
`;

export const StyledProductImgSide = styled.img`
  flex: 1;
  max-width: calc((100% - 32px) / 2);
  object-fit: contain;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 16px;
  display: block;
  background: #f8f8f8;
  aspect-ratio: auto 1232 / 520;

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
    aspect-ratio: auto 1287 / 912;
  }

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    max-width: 100%;
    max-height: 380px;
    aspect-ratio: 360 / 360;
  }
`;

export const StyledProductImgOutlook = styled.img`
  margin-top: 48px;
  max-width: 100%;

  border-radius: 16px;

  object-fit: contain;
`;

export const StyledSpacing64 = styled.div`
  height: 64px;

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
    margin-bottom: 48px;
  }
`;

export const DownloadLayout = styled.div`
  width: 100%;
  height: 100%;
`;

export const SpacingBtn = styled.div`
  margin-top: 48px;

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    margin-top: 64px;
  }
`;

export const DownloadRow = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  padding: 16px 0;
  gap: 33px;
`;

export const PDFimg = styled.img`
  display: flex;
  height: 24px;

  cursor: pointer;
`;

export const DownloadPara = styled(StyledParagraph)`
  width: 44.8%;
`;

export const DownloadDate = styled(StyledParagraph)`
  width : 44.8%;
  color ; #646464;
`;

export const YoutubeIframe = styled.iframe`
  width: 100%;
  height: 100%;
  aspect-ratio: 16/9;
`;
